import React from 'react';
import MiniHeaders from "./mini-headers";
import AccordionExpandIcon from "./acordion-expand";
import {accordionDataFaq} from "../data/mock-date";

const Faq = () => {
    return (
        <div>
            <div className={'blocks-wrapper'}>
                <MiniHeaders headerName={'Հաճախ տրվող հարցեր'} fontSize={29}/>
                <div>
                    <AccordionExpandIcon accordionData={accordionDataFaq} />
                </div>
            </div>
        </div>
    );
};

export default Faq;
